import { useMe } from './useMe'

/**
 * Per-company gate for the entire Hauler (contractor) module surface.
 *
 * Reads the backend-controlled opt-in
 * `CompanySettingsType.haulerModuleEnabled`, part of the `me` query
 * (`GetMeByProjectIds`, `src/api/auth.ts`). Mirrors `useInvoicingEnabled`.
 *
 * FAIL-SAFE: when the field is missing/undefined (e.g. an older backend or a
 * partial cache), the module is treated as OFF — live customers on the old
 * modules must never see hauler surfaces by accident.
 *
 * Route-level gating uses the equivalent `hauler-module` role assigned in
 * `setRoles` (`src/reducers/routing/utils.ts`) from the same `me` payload, so
 * both signals always agree.
 */
export const useHaulerModuleEnabled = (): boolean =>
  Boolean(useMe()?.company?.companySettings?.haulerModuleEnabled)
